import React, { PureComponent, memo } from 'react';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import 'moment/locale/es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faTruck } from '@fortawesome/free-solid-svg-icons';
import { Tabs, Tab } from "react-bootstrap";
import BootstrapTable from 'react-bootstrap-table-next';

import { farmatearMontos } from '../../../../Util/Util.js';
import { Notificacion } from '../../../../Util/Notificacion/Notificacion';
import { Obtener_Formas_Pago_Orden } from '../../../../../request/ProcesosRequest';

class detalleEncabezado extends PureComponent {
    _isMounted = false;
    state = {
        tabActivo: 'general',
        formasPago: []
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async obtenerParametroDiasMonitoreo(pOrdenId) {
        if (this.props.token) {
            const response = await Obtener_Formas_Pago_Orden(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrdenId);
            if (response.Exitoso) {
                this._isMounted && this.setState({ formasPago: response.Datos });
            }
            else {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    onSelectTab = (id) => {
        this.setState({ tabActivo: id });
        if (id === 'formasPago' && (!this.state.formasPago || this.state.formasPago.length === 0)) {
            this.obtenerParametroDiasMonitoreo(this.props.orden.Orden_Id);
        }
    }

    render() {
        const { tabActivo, formasPago } = this.state;
        const { orden, esEcommerce, total, simboloMoneda } = this.props;

        const columnasPagos = [
            { dataField: 'llave', text: 'llave', hidden: true },
            { dataField: 'Nombre_Tipo', text: 'Tipo', sort: true },
            { dataField: 'Pago_Total', text: 'Monto', sort: true, align: 'left', formatter: (row, cell) => { return farmatearMontos(cell.Pago_Total) }, },
            { dataField: 'Moneda_Numero', text: 'Moneda/Núm. Tarjeta', sort: true },
            { dataField: 'Tarjeta_Nombre', text: 'Tarjeta/Banco', sort: false },
            { dataField: 'Tarjeta_Aprobacion', text: 'Autorizado', sort: false }];

        return (
            <div className="datos-orden">
                <Tabs defaultActiveKey={"general"} activeKey={tabActivo} id="detallesOrden" onSelect={this.onSelectTab}>
                    <Tab eventKey="general" title={"General"}>
                        <div className="row">
                            <div className="col-md-9">
                                <p>Ordenado el <Moment locale="es" format="LL" date={orden.Fecha_Registro}></Moment></p>
                                <label>Dirección de Entrega</label>
                                <p>{orden.Ubicacion_Nombre}</p>
                                {
                                    orden.Nivel1_Nombre ?
                                        <p>{orden.Nivel1_Nombre}, {orden.Nivel2_Nombre}, {orden.Nivel3_Nombre}, {orden.Nivel4_Nombre}</p>
                                        : null
                                }
                                {
                                    orden.Direccion ?
                                        <p>{orden.Direccion}</p>
                                        : null
                                }
                                <p>Observaciones: {orden.Observaciones}</p>
                            </div>
                            <div className="col-md-3 pull-right">
                                <p>Tipo de Entrega: {orden.Tipo_Entrega === "Tienda" ? <FontAwesomeIcon icon={faStore} className="mr-1" /> : <FontAwesomeIcon icon={faTruck} className="mr-1" />} {orden.Tipo_Entrega}</p>
                                <p>Origen: {esEcommerce ? 'Ecommerce' : 'Express'}</p>
                                <p>Cliente: {`${orden.Cliente_Id} - ${orden.Cliente_Nombre}`}</p>
                                <p>Teléfono: {orden.Telefono}</p>
                                <p>Usuario: {orden.Usuario_Registro}</p>
                                <label>Total: {simboloMoneda}{farmatearMontos(total)}</label>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="formasPago" title={'Formas de Pago'}>
                        <div className="row">
                            <BootstrapTable keyField='llave' data={formasPago} columns={columnasPagos} />
                        </div>
                    </Tab>
                    {
                        orden.Instrucciones_Entrega ?
                            <Tab eventKey="intruccionesEntrega" title={'Instrucciones de Entrega'}>
                                <div className="row">
                                    <p className="break-word">{orden.Instrucciones_Entrega}</p>
                                </div>
                            </Tab>
                            : null
                    }
                </Tabs>
            </div>
        )
    }
};

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        callCenter: state.parametros.callCenter,
        simboloMoneda: state.parametros.simboloMoneda
    };
};

export default connect(mapStateToProps)(memo(detalleEncabezado));